<template>
  <router-view/>
  <!-- <div id="app">
    <input v-model="searchParam.startTime" placeholder="开始时间">
    <input v-model="searchParam.endTime" placeholder="结束时间">
    <input v-model="searchParam.year" placeholder="年份">
    <button @click="changeParam"></button>
  </div> -->
</template>



<script>
  // import {
  //   SocketInit
  // } from '@/utils/websocket/socketUtil.js'
  
  export default {
    name: 'App',
    // mixins: [SocketInit], //混入文件
    components: {

    },
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {
      // acceptEquData(data) {
      //   console.log("设备信息----------",data)
      // },
      // acceptRepairData(data) {
      //   console.log("维修信息----------",data)
      // },
      // acceptMaintainData(data) {
      //   console.log("保养信息----------",data)
      // },
      // acceptInspectData(data) {
      //   console.log("巡检信息----------",data)
      // },
      // acceptWeatherData(data) {
      //   console.log("天气信息----------",data)
      // },
      // acceptUsersData(data){
      //   console.log("用户信息----------",data)
      // },
      // acceptStatisticsData(data){
      //   console.log("统计信息----------",data)
      // }
    }
  }
</script>

<style lang="less">
@import "./style/font.less";
 html, body, *{
  padding: 0;
  margin: 0;
  font-family: "DIN-BOLD";
}
</style>



// WEBPACK FOOTER //
// src/App.vue